import { useEffect } from 'react';
import { useMarketWebSocketSender } from '../../../hooks/ws/useMarketWebSocketSender.ts';
import { MsgTypeSubscriptionRequest, SubscriptionRequest } from '@/api/spec.ts';
import { useCandlestickChartStore } from '../CandlestickChartStore.ts';
import { DexIntervalMapper } from './DexIntervalMapper.ts';

export type UseDexCandlesOptions = {
  symbol?: string;
  enabled: boolean;
};

const intervalMapper = new DexIntervalMapper();

export function useDexCandlesSubscriptions({ symbol, enabled = true }: UseDexCandlesOptions) {
  const { sendMessage } = useMarketWebSocketSender();
  const resolution = useCandlestickChartStore((s) => s.resolution);

  const xResolution = intervalMapper.getExchangeInterval(resolution);

  useEffect(() => {
    if (!enabled || !symbol || !xResolution || !sendMessage) {
      return;
    }

    const stream = `candles@${symbol}*${xResolution}`;
    sendMessage<SubscriptionRequest>({
      mt: MsgTypeSubscriptionRequest,
      subs: [{ stream, subscribe: true }],
    });

    return () => {
      sendMessage<SubscriptionRequest>({
        mt: MsgTypeSubscriptionRequest,
        subs: [{ stream, subscribe: false }],
      });
    };
  }, [symbol, xResolution, enabled, sendMessage]);
}
